import { connect } from 'react-redux';

import {
    filterActions,
    filterSelectors,
} from 'wanderu-ducks-search';

import SearchFilters from '../../components/SearchFilters/SearchFilters';

const mapDispatchToProps = {
    resetArrivalStations: filterActions.resetArriveStations,
    resetArrivalTiming: filterActions.resetArrivalTiming,
    resetDepartureStations: filterActions.resetDepartStations,
    resetDepartureTiming: filterActions.resetDepartureTiming,
    resetFeatures: filterActions.resetFeatures,
    resetTravelModes: filterActions.resetTravelModes,
    setAllowNearbyActive: filterActions.setAllowNearbyActive,
    setArrivalStationActive: filterActions.setArriveStationActive,
    setArrivalStationOnlyActive: filterActions.setArriveStationOnlyActive,
    setArrivalTimingRange: filterActions.setArrivalTimingRange,
    setCarrierActive: filterActions.setCarrierActive,
    setCarrierOnlyActive: filterActions.setCarrierOnlyActive,
    setDepartureStationActive: filterActions.setDepartStationActive,
    setDepartureStationOnlyActive: filterActions.setDepartStationOnlyActive,
    setDepartureTimingRange: filterActions.setDepartureTimingRange,
    setDirectOnlyActive: filterActions.setDirectOnlyActive,
    setFeatureActive: filterActions.setFeatureActive,
    setTravelModeActive: filterActions.setTravelModeActive,
    setTravelModeOnlyActive: filterActions.setTravelModeOnlyActive,
};

function mapStateToProps(state) {
    return {
        filters: filterSelectors.selectFilters(state),
        isArrivalStationsFiltered: filterSelectors.selectArriveStationsIsFiltered(state),
        isArrivalTimingFiltered: filterSelectors.selectArrivalTimingIsFiltered(state),
        isDepartureStationsFiltered: filterSelectors.selectDepartStationsIsFiltered(state),
        isDepartureTimingFiltered: filterSelectors.selectDepartureTimingIsFiltered(state),
        isFeaturesFiltered: filterSelectors.selectFeaturesIsFiltered(state),
        isTravelModesFiltered: filterSelectors.selectTravelModesIsFiltered(state),
    };
}

export {
    mapStateToProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilters);
